module.exports = __webpack_public_path__ + "img/humanTopBg.5ae411df.png";